import { createFileRoute } from "@tanstack/react-router";
import { AuthLayout } from "@/shared/layouts/auth-layout";
import { ResetPasswordPage } from "@/shared/pages/auth/reset-password";

export const Route = createFileRoute("/auth/reset-password")({
  component: ResetPasswordRoute,
});

function ResetPasswordRoute() {
  return (
    <AuthLayout>
      <ResetPasswordPage />
    </AuthLayout>
  );
}
